import React from "react";
import "./Organising.css";

const OrganizingCommittee = () => {
  const data = [
    { name: "Prof. Ambuj Sagar", designation: "Deputy Director, Strategy and Planning", email: "ddsp@admin.iitd.ac.in" },
    { name: "Prof. Santanu Chaudhury", designation: "Department of Electrical Engineering", email: "santanuc@ee.iitd.ac.in" },
    { name: "Prof. Tapan K. Gandhi", designation: "Department of Electrical Engineering", email: "tgandhi@ee.iitd.ac.in" },
    { name: "Prof. Samar Husain", designation: "Department of Humanities and Social Sciences", email: "samar@hss.iitd.ac.in" },
    { name: "Prof. Aarat P. Kalra", designation: "Centre for Biomedical Engineering", email: "aaratkalra@cbme.iitd.ac.in" },
    { name: "Prof. Saurabh Raj", designation: "Kusuma School of Biological Sciences", email: "sraj@bioschool.iitd.ac.in" },
    { name: "Prof. Sumeet Agarwal", designation: "Yardi School of Artificial Intelligence", email: "sumeet@scai.iitd.ac.in" },
  ];

  return (
    <div className="main-container-anti">
      <div className="box-wrap">
        <div className="table-container">
          <h1 className="mb-2 mt-5 text-center h1title">
            <span style={{ color: "#c21717" }}>ORGANISING</span>{" "}
            <span>COMMITTEE</span>
          </h1>
          <h6 className="text-center mb-4" style={{fontWeight:"bold"}}>Committee Members</h6>
          <div className="table-wrap">
            <table>
              <thead>
                <tr>
                  <th className="thanti">S. No.</th>
                  <th className="thanti">Name</th>
                  <th className="thanti">Department</th>
                  <th className="thanti">Email</th>
                </tr>
              </thead>
              <tbody>
                {data.map((elem, index) => (
                  <tr key={index}>
                    <td className="tdanti">{index + 1}</td>
                    <td className="tdanti">{elem.name}</td>
                    <td className="tdanti" style={{textTransform:"none"}}>{elem.designation}</td>
                    <td className="tdanti" style={{textTransform:"lowercase"}}><a href={"mailto:"+elem.email}>{elem.email}</a></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizingCommittee;